import { render, staticRenderFns } from "./AccountManagementModalTabs.vue?vue&type=template&id=b3192bbe&scoped=true&"
import script from "./AccountManagementModalTabs.vue?vue&type=script&lang=ts&"
export * from "./AccountManagementModalTabs.vue?vue&type=script&lang=ts&"
import style0 from "./AccountManagementModalTabs.vue?vue&type=style&index=0&id=b3192bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3192bbe",
  null
  
)

export default component.exports